import React, { useState } from 'react';

// Key the error state by ID so changing a row's stock never retains an old 404.
const StockSparklineImage = ({ stockId, stockName, className }) => {
  const [graphError, setGraphError] = useState(false);
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  if (!stockId || !supabaseUrl || graphError) {
    return <span className="text-gray-400 text-xs">—</span>;
  }
  return (
    <img
      src={`${supabaseUrl.replace(/\/$/, '')}/storage/v1/object/public/graphs/stock-sparklines/${encodeURIComponent(stockId)}.svg`}
      alt={`${stockName || 'Stock'} price graph`}
      className={`${className} rounded`}
      onError={() => setGraphError(true)}
    />
  );
};

const StockSparkline = ({ stockId, stockName, className = 'w-24 h-6' }) => (
  <StockSparklineImage key={stockId} stockId={stockId} stockName={stockName} className={className} />
);

export default StockSparkline;
